
import React from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { useContactForm } from "./useContactForm";
import { ContactFormFields } from "./ContactFormFields";

const ContactForm: React.FC = () => {
  const {
    formData,
    errors,
    isSubmitting,
    handleChange,
    handleSelectChange,
    handleSubmit
  } = useContactForm();

  return (
    <div>
      <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-gray">
        Envoyez-nous un message
      </h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <ContactFormFields
          formData={formData}
          errors={errors}
          onChange={handleChange}
          onSelectChange={handleSelectChange}
        />
        
        <div className="text-sm text-gray-500">
          * Champs obligatoires
        </div>
        
        <div>
          <Button 
            type="submit" 
            className="bg-fabre-green hover:bg-fabre-darkgreen flex items-center"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Envoi en cours..." : "Envoyer le message"}
            <Send className="ml-2 h-4 w-4" />
          </Button>
          <p className="mt-3 text-sm text-gray-600">
            Votre message sera envoyé directement à notre équipe qui vous répondra rapidement.
          </p>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
